/**
 * Dígito de verificación del NIT (DIAN, Orden Administrativa 4 de 1989): pesos de derecha a izquierda, módulo 11.
 * Extraído del dominio del ERP para que todas las apps calculen lo mismo.
 */
const WEIGHTS = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
export class InvalidNitError extends Error {
    constructor(nit) {
        super(`NIT inválido: "${nit}"`);
    }
}
/** Solo los dígitos del NIT (sin DV, puntos ni guiones). */
export function nitDigits(nit) {
    return nit.replace(/\D/g, '');
}
export function nitCheckDigit(nit) {
    const digits = nitDigits(nit);
    if (digits.length === 0 || digits.length > 15)
        throw new InvalidNitError(nit);
    let sum = 0;
    for (let i = 0; i < digits.length; i++)
        sum += Number(digits[digits.length - 1 - i]) * (WEIGHTS[i] ?? 0);
    const rest = sum % 11;
    return rest > 1 ? 11 - rest : rest;
}
export function isValidNit(nit, dv) {
    try {
        return nitCheckDigit(nit) === Number(dv);
    }
    catch {
        return false;
    }
}
/** «900.123.456-7» a partir de «900123456» (calcula el DV si no viene). */
export function formatNit(nit, dv) {
    const digits = nitDigits(nit);
    const d = dv ?? nitCheckDigit(digits);
    return `${digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${d}`;
}
/** Separa «900123456-7» (o «900.123.456-7») en NIT y DV; sin guion, el DV se calcula. */
export function parseNit(text) {
    const [left = '', right] = text.trim().split('-');
    const nit = nitDigits(left);
    const dv = right !== undefined && /^\d$/.test(right.trim()) ? Number(right.trim()) : nitCheckDigit(nit);
    return { nit, dv };
}
//# sourceMappingURL=nit.js.map